import { useSelector } from "react-redux";
import { State } from "../../app/store";

export default function useFacility() {
  const facilityIds = useSelector((state: State) => state.config.facilityIds);
  return facilityIds;
}
